export const hasTrialIntent = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  return params.get('intent') === 'trial';
};
